module.exports = __webpack_public_path__ + "assets/img/optimised-system.8862acb6.jpg";